import AdminsContainer from './admins.container';

export default AdminsContainer;
